export enum StudentActivityType {
  Enrol = 'ENROL',
  Quit = 'QUIT',
  Move = 'MOVE',
}

export enum UnenrolmentType {
  Quit = StudentActivityType.Quit,
  Move = StudentActivityType.Move,
}

export enum StudentActivityReasonCategory {
  NeverAttended = 'never_attended',
  TeacherDissatisfaction = 'teacher_dissatisfaction',
  AdminDissatisfaction = 'admin_dissatisfaction',
  ServiceDissatisfaction = 'service_dissatisfaction',
  TooEasy = 'too_easy',
  TooHard = 'too_hard',
  MismatchingSchedule = 'mismatching_schedule',
  Full = 'full',
  ScheduleConflict = 'schedule_conflict',
  Graduation = 'graduation',
  DroppedCourse = 'dropped_course',
  UnaffordableFees = 'unaffordable_fees',
  AlreadyStudied = 'already_studied',
  GeographicalInconvenience = 'geographical_inconvenience',
  NoImprovement = 'no_improvement',
  FriendPreference = 'friend_preference',
  Accident = 'accident',
  ClassCompletion = 'class_completion',
  Unknown = 'unknown',
}
